import React, { useState } from "react";
import "./styles.less";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";
import { useInterval } from "react-use";

export const SolutionSceneKeycloakCompare = () => {
  const { t } = useTranslation();
  const [currentSolutionValue, setCurrentSolutionValue] = useState(
    "value-menu-item-one"
  );
 
  const values = [
    {
      type: "value-menu-item-one",
      title: t("solution.keycloak.compare.item1.title"),
      descript: t("solution.keycloak.compare.item1.descript"),
    },
    {
      type: "value-menu-item-two",
      title: t("solution.keycloak.compare.item2.title"),
      descript: t("solution.keycloak.compare.item2.descript"),
    },
    {
      type: "value-menu-item-three",
      title: t("solution.keycloak.compare.item3.title"),
      descript: t("solution.keycloak.compare.item3.descript"),
    },
     {
      type: "value-menu-item-four",
      title: t("solution.keycloak.compare.item4.title"),
      descript: t("solution.keycloak.compare.item4.descript"),
    },
     {
      type: "value-menu-item-five",
      title: t("solution.keycloak.compare.item5.title"),
      descript: t("solution.keycloak.compare.item5.descript"),
    },
  ];
  const [element, setElement] = useState(1);
  const nextFun = () => {
    if (element > 4) {
      setElement(1);
    } else {
      setElement(element + 1);
    }
  };
  const lastFun = () => {
    if (element <= 1) {
      setElement(4);
    } else {
      setElement(element - 1);
    }
  };
  const industryValueRender = () => {
    return (
      <div className="solution-industry-value-content">
        <div className="solution-industry-value-menu">
          {values.map((item, index) => {
            return (
              <div
                className="value-menu-item"
                key={index}
                onClick={() => {
                  setCurrentSolutionValue(item.type);
                }}
              >
                <span>{item.title}</span>
                <span>
                  <i className="icon authing-icon authing-arrow-right-s-line"></i>
                </span>
              </div>
            );
          })}
        </div>
        <div className="solution-industry-value-text">
          {values.map((item) => {
            if (currentSolutionValue === item.type) {
              return (
                <>
                  <div className="value-text-title">{item.title}</div>
                  <div className="value-text-context">{item.descript}</div>
                </>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  };

  const industryValueMobileRender = () => {
    return (
      <div className="solution-industry-value-mobile">
        <div
          className="last-button"
          onClick={() => {
            lastFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(-90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
        {values.map((item, index) => {
          if (element === index + 1) {
            return (
              <>
                <div className="value-text-title">{item.title}</div>
                <div className="value-text-context">{item.descript}</div>
              </>
            );
          } else {
            return null;
          }
        })}
        <div
          className="next-button"
          onClick={() => {
            nextFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
      </div>
    );
  };
  return (
    <section className="solution-scene-keycloak-compare">
      <div className="inner">
        <Title title={t("solution.keycloak.compare.title")} align="left" />
        {industryValueRender()}
        {industryValueMobileRender()}
      </div>
    </section>
  );
};
